import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=53af330c&scoped=true&"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=53af330c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af330c",
  null
  
)

export default component.exports